import { format, parseISO } from 'date-fns';
import { ja } from 'date-fns/locale';

/**
 * ISO形式の日付文字列を指定されたフォーマットで表示用に変換する
 * @param dateString ISO形式の日付文字列
 * @param formatStr 日付フォーマット（デフォルト: 'yyyy年MM月dd日'）
 * @returns フォーマットされた日付文字列
 */
export const formatDate = (dateString: string, formatStr = 'yyyy年MM月dd日'): string => {
  try {
    if (!dateString) return '日付なし';
    
    // ISO形式でない場合はそのまま返す
    if (!dateString.includes('T') && !dateString.includes('-')) {
      return dateString;
    }
    
    const date = parseISO(dateString);
    return format(date, formatStr, { locale: ja });
  } catch (error) {
    console.error('Date formatting error:', error);
    return dateString || '日付なし';
  }
};

/**
 * HTMLタグを削除してプレーンテキストを取得する
 * @param html HTMLを含む文字列
 * @returns HTMLタグを削除したプレーンテキスト
 */
export const stripHtml = (html: string): string => {
  if (!html) return '';
  return html.replace(/<\/?[^>]+(>|$)/g, '');
};

/**
 * 文字列を指定された長さに切り詰め、必要に応じて省略記号を追加する
 * @param text 元の文字列
 * @param maxLength 最大長
 * @param suffix 省略記号（デフォルト: '...'）
 * @returns 切り詰められた文字列
 */
export const truncateText = (text: string, maxLength: number, suffix = '...'): string => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + suffix;
};

/**
 * スラッグ文字列を生成する（URLフレンドリーな文字列）
 * @param text 元の文字列
 * @returns スラッグ文字列
 */
export const generateSlug = (text: string): string => {
  if (!text) return '';
  
  // 日本語を含む文字列をURLフレンドリーに変換
  return text
    .toLowerCase()
    .replace(/[^\w\s\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]/g, '') // 特殊文字を削除（日本語は保持）
    .replace(/\s+/g, '-') // スペースをハイフンに置換
    .replace(/-+/g, '-') // 連続するハイフンを単一のハイフンに置換
    .replace(/^-+/, '') // 先頭のハイフンを削除
    .replace(/-+$/, ''); // 末尾のハイフンを削除
}; 